/* eslint-disable */
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import dayjs from "dayjs";
import axios from "axios";
import { Chip, TableContainer, Table, TableRow, TableCell, TextField, Button, TableBody, CircularProgress } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Resizer from "react-image-file-resizer";
import { getEquipmentCategoriesByQuery } from "components/axios/equipmentCategoryAxios";
// import { getStationsByQuery } from "components/axios/stationAxios";
// import { getWorkingPartsByQuery } from "components/axios/workingPartAxios";
import { deleteEquipments, getEquipmentsByQuery, getLiftControlPanelsQuery } from "components/axios/equipmentAxios";
import CustomFormEnumSelect from "components/select/CustomFormEnumSelect";
import CustomFormSelect from "components/select/CustomFormSelect";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import MainCard from "components/MainCard";
import FileDownloadIcon from "components/FileDownloadIcon";
import { useEnumApi } from "contexts/EnumApiContext";
import CustomDatePicker from "components/date_picker/CustomDatePicker";
import { customFileAxios } from "components/axios/customAxios";

const EquipmentForm = ({info, setIsLoading:parentSetIsLoading, setEquipmentNoList}) => {
    const { getEnumValueByEnumName, equipmentCategoryLevel1s:level1s } = useEnumApi();
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');
    
    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };

    const regexDate = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
    const navigate = useNavigate();
    // const [workingParts, setWorkingParts] = useState(null);
    // const [stations, setStations] = useState(null);
    const [equipmentCategoryLevel1s, setEquipmentCategoryLevel1s] = useState(null);
    const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState(null);
    const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState(null);
    const [liftControlPanels, setLiftControlPanels] = useState(null);
  
    // const [subwayCode, setSubwayCode] = useState('');
    // const [workingPartId, setWorkingPartId] = useState('');
    // const [stationId, setStationId] = useState('');
    const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState('');
    const [equipmentCategoryLevel1Code, setEquipmentCategoryLevel1Code] = useState('');
    const [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState('');
    const [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    // const [imgFile, setImgFile] = useState(null);
    const [bpFile, setBpFile] = useState(null);
    const [vrFile, setVrFile] = useState(null);
    // const [imgFileId, setImgFileId] = useState(null);
    const [bpFileId, setBpFileId] = useState(null);
    const [fileLoading, setFileLoading] = useState(false);
    const [inputImageItems, setInputImageItems] = useState([]);

    const nextImgID = useRef(1);
    const nextVRID = useRef(1);
    const nextID = useRef(1);
    const [inputVRItems, setInputVRItems] = useState([
         { id: 1, file: null, vId : null, vFile: null }, { id: 2, file: null, vId : null, vFile: null }, { id: 3, file: null, vId : null, vFile: null }, { id: 4, file: null, vId : null, vFile: null }
        ,{ id: 5, file: null, vId : null, vFile: null }, { id: 6, file: null, vId : null, vFile: null }, { id: 7, file: null, vId : null, vFile: null }, { id: 8, file: null, vId : null, vFile: null }
    ]);
    const [inputManualItems, setInputManualItems] = useState([]);

    const { control, register, handleSubmit, setValue, formState : {isDirty, errors } } = useForm({});
 
    function fileChangedHandler(event, maxWith, maxHeight, responseUriFunc) {
        if (event.target?.files?.[0]) {
          try {
            Resizer.imageFileResizer(event.target.files[0], maxWith, maxHeight, "JPEG", 90, 0, responseUriFunc, "file", 0, 0)
          } catch (err) {
            alertMessage = err.message;
            setAlertMessage(alertMessage);
            handleAlertClick();
            responseUriFunc('')
          }
        }
    }

    const resizeFile = (file, maxWidth, maxHeight) =>
        new Promise((res) => {
            Resizer.imageFileResizer(
                file, // target file
                maxWidth, // maxWidth
                maxHeight, // maxHeight
                "JPEG", // compressFormat : Can be either JPEG, PNG or WEBP.
                90, // quality : 0 and 100. Used for the JPEG compression
                0, // rotation
                (uri) => res(uri), // responseUriFunc
                "file" // outputType : Can be either base64, blob or file.(Default type is base64)
                ,0,0	
            );
        }
    );

    useEffect(() => {
        getLiftControlPanelsQuery().then((data) => {
            if (data) {
                setLiftControlPanels([{id:0, name:t('message.common.chip.panel')}, 
                    ...data.map(d=> {return {id:d.id, name:d.firmwareVersion ? `${d.modelName} [${d.firmwareVersion}]` : d.modelName}})])
                // setLiftControlPanels(data);
            } else {
                setLiftControlPanels([{id:0, name:t('message.common.chip.panel')}]);
            }
        });
        setEquipmentCategoryLevel1s(level1s.map(l=>{return{id:l.id+","+l.code, name:l.name}}));
        setIsLoading(true);
    }, []);

    // 호선 선택시 해당 파트 목록 가져오기
    // useEffect(()=>{
    //     if (subwayCode) {
    //         const param = {"subwayLine" : subwayCode, size:50}
    //         getWorkingPartsByQuery(param).then((data)=>{
    //             if (data && data._embedded) {
    //                 let workingParts = data._embedded.workingParts;
    //                 setWorkingParts(workingParts);
    //                 let sId = workingPartId || (info && info.station && info.station.workingPart && info.station.workingPart.id) || '';
    //                 setWorkingPartId(sId);
    //                 let belongDatas = data._embedded.workingParts.filter(item=> item.id == sId);
    //                 if (workingPartId && belongDatas && belongDatas.length > 0) {
    //                     setValue("workingPartId", workingPartId);
    //                 } else if (info && info.station && info.station.workingPart) {
    //                     setValue("workingPartId", (info.station.workingPart.id || ''));
    //                 } else {
    //                     setWorkingPartId('');
    //                   setValue("workingPartId", '');
    //                 }
    //                 setValue("stationId",'');
    //                 setStations(null);
    //             } else {
    //                 setWorkingPartId('');
    //                 setValue("workingPartId", '');
    //                 setWorkingParts(null);

    //                 setValue("stationId",'');
    //                 setStations(null);
    //             }
    //         });
    //     }
    // },[subwayCode]);

    // // 파트 선택시 해당 역사 목록 가져오기
    // useEffect(()=>{
    //     if (workingPartId) {
    //     const param = {"workingPart.id" : workingPartId, sort:"code,asc", size:50};
    //     getStationsByQuery(param).then((data)=>{
    //         if (data && data._embedded) {
    //             setStations(data._embedded.stations);
    //             let sId = (info && info.station && info.station.id) || '';
    //             let belongDatas = data._embedded.stations.filter(item=> item.id == sId);
    //             if (sId && belongDatas && belongDatas.length > 0) {
    //                 setValue("stationId", sId);
    //             } else if (info && info.station) {
    //                 setValue("stationId", (info.station.id || ''));
    //             } else {
    //                 setValue("stationId", '');
    //             }
                
    //         } else {
    //             setValue("stationId", '');
    //             setStations(null);
    //         }
    //     });
    //     }
    // },[workingPartId]);

    // 설비중분류 목록
    useEffect(()=>{
        if (equipmentCategoryLevel1Id) {
            const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
            getEquipmentCategoriesByQuery(param).then((data) => {
                if (data && data._embedded) {
                    const list = data._embedded.equipmentCategories;
                    if (list) {
                        setEquipmentCategoryLevel2s(list);
                        let sId = (equipmentCategoryLevel2Id || (info && info.equipmentCtgr && info.equipmentCtgr.parent && info.equipmentCtgr.parent.id) || '');
                        setEquipmentCategoryLevel2Id(sId);
                        let belongDatas = data._embedded.equipmentCategories.filter(item=> item.id == sId);
                        if (equipmentCategoryLevel2Id && belongDatas && belongDatas.length > 0) {
                            setValue("equipmentCategoryLevel2Id", equipmentCategoryLevel2Id);
                        } else if (info && info.equipmentCtgr && info.equipmentCtgr.parent) {
                            setValue("equipmentCategoryLevel2Id", (info.equipmentCtgr.parent.id || null));
                        } else {
                            setValue("equipmentCategoryLevel2Id", '');
                        }
                    } else {
                        setEquipmentCategoryLevel2Id('');
                        setValue("equipmentCategoryLevel2Id",'');
                        setEquipmentCategoryLevel2s([]);
                    }
                    setEquipmentCategoryLevel3Id('');
                    setValue("equipmentCategoryLevel3Id",'');
                    setEquipmentCategoryLevel3s([]);
                } else {
                    setEquipmentCategoryLevel2Id('');
                    setValue("equipmentCategoryLevel2Id",'');
                    setEquipmentCategoryLevel2s([]);

                    setEquipmentCategoryLevel3Id('');
                    setValue("equipmentCategoryLevel3Id",'');
                    setEquipmentCategoryLevel3s([]);
                }
            });
        }
    },[equipmentCategoryLevel1Id]);

    // 설비분류 목록
    useEffect(()=>{
        if (equipmentCategoryLevel2Id) {
            const param = { "parent.id": equipmentCategoryLevel2Id, depth: 3, size : 100, sort : "name,asc" };
            getEquipmentCategoriesByQuery(param).then((data) => {
                if (data && data._embedded) {
                    const list = data._embedded.equipmentCategories;
                    if (list) {
                        setEquipmentCategoryLevel3s(list);
                        let sId = (equipmentCategoryLevel3Id || (info && info.equipmentCtgr && info.equipmentCtgr.id) || '');
                        setEquipmentCategoryLevel3Id(sId);
                        let belongDatas = data._embedded.equipmentCategories.filter(item=> item.id == sId);
                        if (equipmentCategoryLevel3Id && belongDatas && belongDatas.length > 0) {
                            setValue("equipmentCategoryLevel3Id", equipmentCategoryLevel3Id);
                        } else if (info && info.equipmentCtgr) {
                            setValue("equipmentCategoryLevel3Id", (info.equipmentCtgr.id || null));
                        } else {
                            setEquipmentCategoryLevel3Id('');
                            setValue("equipmentCategoryLevel3Id", '');
                          }
                      } else {
                          setEquipmentCategoryLevel3Id('');
                          setValue("equipmentCategoryLevel3Id", '');
                          setEquipmentCategoryLevel3s([]);
                      }
                  } else {
                      setEquipmentCategoryLevel3Id('');
                      setValue("equipmentCategoryLevel3Id", '');
                      setEquipmentCategoryLevel3s([]);
                }
            });
        }
    },[equipmentCategoryLevel2Id]);
    
    useEffect(()=>{
        if (info) {
            // if (info.station && info.station.workingPart) {
            //     setSubwayCode(info.station.workingPart.subwayLine);
            //     setWorkingPartId(info.station.workingPart.id);
            // }

            if (info.equipmentCtgr) {
                if (info.equipmentCtgr.parent) {
                    if (info.equipmentCtgr.parent.parent) {
                        setEquipmentCategoryLevel1Id(info.equipmentCtgr.parent.parent.id);
                        setEquipmentCategoryLevel1Code(info.equipmentCtgr.parent.parent.code);
                    }
                    setEquipmentCategoryLevel2Id(info.equipmentCtgr.parent.id);
                }
            }
            // setValue("subwayCode", info.station && info.station.workingPart && (info.station.workingPart.subwayLine || ''));
            setValue("opStatus", info.opStatus || '');
            setValue("madeYmd", info.madeYmd || null);
            setValue("instlYmd", info.instlYmd || null);
            setValue("disposalYmd", info.disposalYmd || null);
            setValue("name", info.name || '');
            setValue("equipmentNo", info.equipmentNo || '');
            setValue("location", info.location || '');
            setValue("mfCpnyNm", info.mfCpnyNm || '');
            setValue("remark", info.remark || '');
            setValue("controlPanelId", info?.controlPanel?.id || 0);
            // console.log(info?.controlPanel?.id || 0)
            // if (info.equipmentCtgr.parent.parent.code === 'EV' || info.equipmentCtgr.parent.parent.code === 'ES') {
            //     setValue("controlPanelId", info?.controlPanel?.id || '0');
            // } else {
            //     setValue("controlPanelId", '0');
            // }

            // setImgFileId((info.imgFile && (info.imgFile.id || null)));
            setBpFileId((info.bpFile && (info.bpFile.id || null)));

            if (info.imgFiles) {
                let inputImageItemsCopy = [];
                nextImgID.current = 1;
                for (var j=0;j<info.imgFiles.length;j++) {
                    const input = {	
                        id: nextImgID.current,
                        file: {},
                        imgFile: info.imgFiles[j],
                    };
                    inputImageItemsCopy = [...inputImageItemsCopy, input]
                    nextImgID.current += 1;
                }
                setInputImageItems(inputImageItemsCopy);
            }

            if (info.vrFiles) {
                let inputVRItemsCopy = [...inputVRItems];
                for (var i=0;i<info.vrFiles.length;i++) {
                    var vFileIdx = inputVRItems.findIndex(item => item.id === info.vrFiles[i].sortOrder);
                    //console.log(vFileIdx)
                    inputVRItemsCopy[vFileIdx].vId = info.vrFiles[i].id;
                    inputVRItemsCopy[vFileIdx].vFile = info.vrFiles[i].file;
                }
                setInputVRItems(inputVRItemsCopy);
            }
            
            if (info.files) {
                let inputManualItemsCopy = [];
                nextID.current = 1;
                for (var j=0;j<info.files.length;j++) {
                    const input = {	
                        id: nextID.current,
                        file: {},
                        mFile: info.files[j],
                    };
                    inputManualItemsCopy = [...inputManualItemsCopy, input]
                    nextID.current += 1;
                }
                setInputManualItems(inputManualItemsCopy);
            }
        }
    },[info]);

    function addImageFile(file) {
        const input = {	
            id: nextImgID.current,
            file: {},
            imgFile: file,
        };

        setInputImageItems([...inputImageItems, input]);
        nextImgID.current += 1;
    }

    // 삭제
    function deleteImageFile(index) {
        setInputImageItems(inputImageItems.filter(item => item.id !== index));
    }

    async function handleImageFileChange(e, index) {
        if (index > inputImageItems.length) return;

        const compressedFile = (await resizeFile(e.target.files[0], 640, 480));
        
        let inputItemsCopy = [...inputImageItems];
        inputItemsCopy[index].file = compressedFile;
        inputItemsCopy[index].imgFile = null;

        setInputImageItems(inputItemsCopy);
    }

    function addVRFile(id, file) {
        const input = {	
            id: nextVRID.current,
            file: {},
            vId : id,
            vFile: file,
        };

        setInputVRItems([...inputVRItems, input]);
        nextVRID.current += 1;
    }
    
    // 삭제
    function deleteInputVRFile(index) {
        let inputVRItemsCopy = [...inputVRItems];
        inputVRItemsCopy[index-1].file = null;
        inputVRItemsCopy[index-1].vId = null;
        inputVRItemsCopy[index-1].vFile = null;
        setInputVRItems(inputVRItemsCopy);
    }

    async function handleInputVRFileChange(e, index) {
        if (index > inputVRItems.length) return;

        const compressedFile = (await resizeFile(e.target.files[0], 5000, 3750));
        
        let inputVRItemsCopy = [...inputVRItems];
        inputVRItemsCopy[index].file = compressedFile;
        inputVRItemsCopy[index].vId = null;
        inputVRItemsCopy[index].vFile = null;
        setInputVRItems(inputVRItemsCopy);
    }

    function addManualFile(file) {
        const input = {	
            id: nextID.current,
            file: {},
            mFile: file,
        };

        setInputManualItems([...inputManualItems, input]);
        nextID.current += 1;
    }

    // 삭제
    function deleteManualFile(index) {
        setInputManualItems(inputManualItems.filter(item => item.id !== index));
    }

    function handleManualFileChange(e, index) {
        if (index > inputManualItems.length) return;
        
        let inputItemsCopy = [...inputManualItems];
        inputItemsCopy[index].file = e.target.files[0];
        inputItemsCopy[index].mFile = null;
        setInputManualItems(inputItemsCopy);
    }

    // 기본이미지삭제
    // function deleteImgFile() {
    //     setImgFileId(null);
    // }

    // 도면이미지삭제
    function deleteBpFile() {
        setBpFileId(null);
    }

    // 설비 등록/수정
    const onSubmit = (data, e) => {
        e.preventDefault();
        setFileLoading(true);

        const equipmentId = data.id;
        // const subwayCode = data.subwayCode;
        // const workingPartId = data.workingPartId;
        // const stationId = data.stationId;
        const subwayCode = "I1";
        const workingPartId = 1;
        const stationId = 51;
        const equipmentCategoryLevel1Id = data.equipmentCategoryLevel1Id;
        const equipmentCategoryLevel2Id = data.equipmentCategoryLevel2Id;
        const equipmentCategoryLevel3Id = data.equipmentCategoryLevel3Id;
        const equipmentNo = data.equipmentNo;
        const name = data.name;
        const location = data.location;
        const mfCpnyNm = data.mfCpnyNm;
        const madeYmd = data.madeYmd;
        const instlYmd = data.instlYmd;
        
        const remark = data.remark;
        const opStatus = data.opStatus;
        const disposalYmd = data.disposalYmd;

        if (data.madeYmd != null && data.madeYmd != '' && !regexDate.test(data.madeYmd)) {
            alertMessage = t('message.common.alert.production.date.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            setFileLoading(false);
            return;
        }

        if (data.instlYmd != null && data.instlYmd != '' && !regexDate.test(data.instlYmd)) {
            alertMessage = t('message.common.alert.installation.date.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            setFileLoading(false);
            return;
        }

        if (data.disposalYmd != null && data.disposalYmd != '' && !regexDate.test(data.disposalYmd)) {
            alertMessage = t('message.common.alert.disposal.date.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            setFileLoading(false);
            return;
        }

        let dto = {
            id: equipmentId,
            station : {id : stationId},
            equipmentCtgr: {
                id: equipmentCategoryLevel3Id
            },
            equipmentNo,
            name,
            location,
            mfCpnyNm,
            madeYmd,
            instlYmd,
            remark,
            opStatus,
            disposalYmd,
        };
        
        // if (equipmentCategoryLevel1Code === 'EV' || equipmentCategoryLevel1Code === 'ES') {
        if (data.controlPanelId > 0) {
            dto.controlPanel = {id : data.controlPanelId};
        }

        let formData = new FormData();
        if(inputImageItems) {
            for (var r=0;r<inputImageItems.length;r++) {
                // console.log(inputImageItems[r].file)
                if (inputImageItems[r].file && inputImageItems[r].file.name) {
                    // console.log(inputImageItems[r].file)
                    formData.append("imgFiles", inputImageItems[r].file);
                }
            }
        }
        formData.append("bpFile", bpFile);
        if(inputVRItems) {
            for (var k=0;k<inputVRItems.length;k++) {
                if (inputVRItems[k].file && inputVRItems[k].file.name) {
                    formData.append("vrFile"+(k+1), inputVRItems[k].file);
                }
            }
        }

        if(inputManualItems) {
            for (var l=0;l<inputManualItems.length;l++) {
                if (inputManualItems[l].file && inputManualItems[l].file.name)
                    formData.append("files", inputManualItems[l].file);
            }
        }

        console.log(dto)
        try {
            if (equipmentId) {  // 수정
                delete dto.equipmentCtgr;
                // if (!imgFile && (imgFileId && imgFileId !== 0)) {
                //     dto.imgFile = {id : imgFileId};
                // }
                // console.log(inputImageItems)
                // console.log(inputImageItems.length)
                if (inputImageItems) {
                    let imgFiles = [];
                    for (var a1=0;a1<inputImageItems.length;a1++) {
                        if (inputImageItems[a1].imgFile && inputImageItems[a1].imgFile.id)
                            imgFiles.push({id : inputImageItems[a1].imgFile.id});
                    }
                    dto.imgFiles = imgFiles;
                }
                if (!bpFile  && (bpFileId && bpFileId !== 0)) {
                    dto.bpFile = {id : bpFileId};
                }
                if (inputVRItems) {
                    let vFiles = [];
                    for (var a=0;a<inputVRItems.length;a++) {
                        if (inputVRItems[a].vId)
                            vFiles.push({id : inputVRItems[a].vId});
                    }
                    dto.vrFiles = vFiles;
                }

                if (inputManualItems) {
                    let mFiles = [];
                    for (var a2=0;a2<inputManualItems.length;a2++) {
                        if (inputManualItems[a2].mFile && inputManualItems[a2].mFile.id)
                            mFiles.push({id : inputManualItems[a2].mFile.id});
                    }
                    dto.files = mFiles;
                }
                console.log(dto)
                formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );

                openModal(modals.confirmModal, {
                    onSubmit : (value) => {
                        try {
                            const res = customFileAxios.patch(`/api/equipments/${equipmentId}`, formData).then((res)=>{
                                setFileLoading(false);
                                parentSetIsLoading(false);
                                alertMessage = t('message.common.alert.modify.done');
                                setAlertMessage(alertMessage);
                                handleAlertClick();
                            }).catch((err)=>{
                                console.log(err);
                                setFileLoading(false);
                                if (!err.response?.data?.message) {
                                    alertMessage = err.message;
                                    setAlertMessage(alertMessage);
                                    handleAlertClick();
                                } else if (err.response.data.message) {
                                    alertMessage = err.response.data.message;
                                    setAlertMessage(alertMessage);
                                    handleAlertClick();
                                }
                            });
                            // return res.data;
                        } catch (error) {
                            console.error("error :", error);
                            throw error;
                        }

                    },
                    onClose : () => {
                        setFileLoading(false);
                        console.log('close');
                    },
                    message: t('message.common.alert.modify.question'),
                });
            } else {    // 등록
                formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
                let vrFileIdxs = [];
                for (var value2 of formData.entries()) {
                    if (value2[0].indexOf('vrFile') !== -1) {
                        vrFileIdxs.push(value2[0].replace('vrFile',''));
                    }
                }

                if (vrFileIdxs.length !== 0 && vrFileIdxs.length !== Math.max.apply(null, vrFileIdxs)) {
                    alertMessage = t('message.common.alert.vr.equipment.picture.order.write');
                    setAlertMessage(alertMessage);
                    handleAlertClick();
                    return;
                }

                openModal(modals.confirmModal, {
                    onSubmit : (value) => {
                        try {
                            const res = customFileAxios.post(`/api/equipments`, formData).then((res)=>{
                                setFileLoading(false);
                                parentSetIsLoading(false);
                                //console.log(res);
                                alertMessage = t('message.common.alert.write.done');
                                setAlertMessage(alertMessage);
                                handleAlertClick();
                                navigate('../modify/'+res.data.id+window.location.search);
                            }).catch((err)=>{
                                console.log(err);
                                setFileLoading(false);
                                if (!err.response?.data?.message) {
                                    alertMessage = err.message;
                                    setAlertMessage(alertMessage);
                                    handleAlertClick();
                                } else if (err.response.data.message) {
                                    alertMessage = err.response.data.message;
                                    setAlertMessage(alertMessage);
                                    handleAlertClick();
                                }
                            });
                            // return res.data;
                        } catch (error) {
                            console.error("error :", error);
                            throw error;
                        }
                    },
                    onClose : () => {
                        setFileLoading(false);
                        console.log('close');
                    },
                    message: t('message.common.alert.write.question'),
                });
            }
        } catch(error) {
            console.log(error);
            setFileLoading(false);
        }
    }
    
    const handleDeleteBtnClick = (param) => {
        if (param) {
            openModal(modals.confirmModal, {
            onSubmit : (value) => {
                deleteEquipments(param).then((res) => {
                    navigate('../../'+window.location.search);
                }).catch((err)=>{
                    console.log(err);
                    if (!err.response?.data?.message) {
                        alertMessage = err.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    } else if (err.response.data.message) {
                        alertMessage = err.response.data.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    }
                });
            },
            onClose : () => {
                console.log('close');
            },
            message: t('message.common.alert.delete.question'),
            });
        }
    }

    const equipmentNoSearch = () => {
        let param = {
            // "station.workingPart.subwayLine" : subwayCode,
            // "station.workingPart.id" : workingPartId,
            // "station.id" : stationId,
            "equipmentCtgr.parent.parent.id" : equipmentCategoryLevel1Id,
            "equipmentCtgr.parent.id" : equipmentCategoryLevel2Id,
            "equipmentCtgr.id" : equipmentCategoryLevel3Id,
        };

        // if (subwayCode === null || subwayCode === '') {
        //     alertMessage = t('message.common.alert.subwayline.select');
        //     setAlertMessage(alertMessage);
        //     handleAlertClick();
        //     return;
        // }
        // if (workingPartId === null || workingPartId === '') {
        //     alertMessage = t('message.common.alert.workingPart.select');
        //     setAlertMessage(alertMessage);
        //     handleAlertClick();
        //     return;
        // }
        // if (stationId === null || stationId === '') {
        //     alertMessage = t('message.common.alert.station.select');
        //     setAlertMessage(alertMessage);
        //     handleAlertClick();
        //     return;
        // }
        if (equipmentCategoryLevel1Id === null || equipmentCategoryLevel1Id === '') {
            alertMessage = t('message.common.alert.level1.select');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }
        if (equipmentCategoryLevel2Id === null || equipmentCategoryLevel2Id === '') {
            alertMessage = t('message.common.alert.level2.select');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }
        if (equipmentCategoryLevel3Id === null || equipmentCategoryLevel3Id === '') {
            alertMessage = t('message.common.alert.level3.select');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }
        getEquipmentsByQuery(param).then((data)=>{
            if (data?._embedded?.equipments != null) {
                setEquipmentNoList(data?._embedded?.equipments);
            } else {
                setEquipmentNoList([]);
            }
        })
    }

    if (info) { // 수정
        return (
        <>
            <MainCard style={{marginTop:"10px"}}>
                <div style={{marginBottom:"10px"}}>
                    <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                    <Chip label={t('message.common.chip.equipment.information')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />
                </div>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <TableContainer style={{width:"100%"}}>
                        <Table sx={{ minWidth: 400 }} aria-label="simple table" style={{borderTop:"2px solid #a2a2a2"}}>
                            <TableBody style={{height:"auto"}}>
                                {/* <TableRow style={{marginTop:"5px"}}>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.subwayline')}</TableCell>
                                    <TableCell className="email_pl">
                                        
                                        {getEnumValueByEnumName("SubwayLine") &&
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.subwayCode ? "true" : "false"}
                                            control={control}
                                            name="subwayCode"
                                            render={({ field: {name} }) => (
                                            <CustomFormEnumSelect
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.subwayline')}
                                                register={register}
                                                name={name}
                                                requiredMessage={t('message.common.error.text.subwayline.select')}
                                                defaultValue={info.station && info.station.workingPart && (info.station.workingPart.subwayLine || '')}
                                                onChange={(e)=>{
                                                    setSubwayCode(e.target.value);
                                                }}
                                                list={getEnumValueByEnumName("SubwayLine")}
                                            />
                                            )}
                                        />
                                        }
                                        {errors.subwayCode && <small role="alert"><br></br>{errors.subwayCode.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.workingPart')}</TableCell>
                                    <TableCell className="email_pl">
                                        {workingParts &&
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.workingPartId ? "true" : "false"}
                                            control={control}
                                            name="workingPartId"
                                            render={({ field: {name} }) => (
                                            <CustomFormSelect
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.workingPart')}
                                                register={register}
                                                name={name}
                                                requiredMessage={t('message.common.error.text.workingPart.select')}
                                                defaultValue={info.station && info.station.workingPart && (info.station.workingPart.id || '')}
                                                onChange={(e)=>{
                                                    setWorkingPartId(e.target.value);
                                                }}
                                                list={workingParts}
                                            />
                                            )}
                                        />
                                        }
                                        {errors.workingPartId && <small role="alert"><br></br>{errors.workingPartId.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.station')}</TableCell>
                                    <TableCell className="email_pl">
                                        {stations &&
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.stationId ? "true" : "false"}
                                            control={control}
                                            name="stationId"
                                            render={({ field: {name} }) => (
                                            <CustomFormSelect
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.station')}
                                                register={register}
                                                name={name}
                                                requiredMessage={t('message.common.error.text.station.select')}
                                                defaultValue={info.station && (info.station.id || '')}
                                                list={stations}
                                            />
                                            )}
                                        />
                                        }
                                        {errors.stationId && <small role="alert"><br></br>{errors.stationId.message}</small>}
                                    </TableCell>
                                </TableRow> */}
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level1')}</TableCell>
                                    <TableCell>
                                        <input type="hidden" {...register("id")} value={info && (info.id || '')} />
                                        {info.equipmentCtgr && info.equipmentCtgr.parent && info.equipmentCtgr.parent.parent && (info.equipmentCtgr.parent.parent.name || '')}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level2')}</TableCell>
                                    <TableCell>
                                        {info.equipmentCtgr && info.equipmentCtgr.parent && (info.equipmentCtgr.parent.name || '')}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level3')}</TableCell>
                                    <TableCell>
                                        {info.equipmentCtgr && (info.equipmentCtgr.name || '')}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.name')}</TableCell>
                                    <TableCell colSpan={3} className="email_pl">
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.name ? "true" : "false"}
                                            defaultValue={info.name || ''}
                                            {...register("name", {
                                                required : t('message.common.alert.equipment.name.input')
                                            })} 
                                            sx={{ minWidth: '90%', backgroundColor: "#fff" }} />
                                        {errors.name && <small role="alert"><br></br>{errors.name.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.number')}</TableCell>
                                    <TableCell className="email_pl">
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.equipmentNo ? "true" : "false"}
                                            defaultValue={info.equipmentNo || ''}
                                            {...register("equipmentNo", {
                                                required : t('message.common.error.text.equipment.number.input')
                                            })} 
                                            sx={{ minWidth: '60%' , backgroundColor: "#fff"}} />
                                        {errors.equipmentNo && <small role="alert"><br></br>{errors.equipmentNo.message}</small>}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.installation.location')}</TableCell>
                                    <TableCell colSpan={3} className="email_pl">
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.location ? "true" : "false"}
                                            defaultValue={info.location || ''}
                                            {...register("location", {
                                                required : t('message.common.error.text.installation.location.input')
                                            })} 
                                            sx={{ minWidth: '90%', backgroundColor: "#fff" }} />
                                        {errors.location && <small role="alert"><br></br>{errors.location.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.mfCpnyNm')}</TableCell>
                                    <TableCell className="email_pl">
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.mfCpnyNm ? "true" : "false"}
                                            defaultValue={info.mfCpnyNm || ''}
                                            {...register("mfCpnyNm", {
                                                required : t('message.common.error.text.production.company.input')
                                            })} 
                                            sx={{ minWidth: '60%', backgroundColor: "#fff" }} />
                                        {errors.mfCpnyNm && <small role="alert"><br></br>{errors.mfCpnyNm.message}</small>}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.madeYmd')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            control={control}
                                            name="madeYmd"
                                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                                            <CustomDatePicker
                                                defaultValue={info.madeYmd || null}
                                                field={field} ref={ref} name={name} value={value} register={register} 
                                                setValue={setValue} fieldState={fieldState}
                                            />
                                            )}
                                        />
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.installation.date')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            control={control}
                                            name="instlYmd"
                                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                                            <CustomDatePicker 
                                                defaultValue={info.instlYmd || null}
                                                field={field} ref={ref} name={name} value={value} register={register} 
                                                setValue={setValue} fieldState={fieldState}
                                            />
                                            )}
                                        />
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.disposal.date')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            control={control}
                                            name="disposalYmd"
                                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                                            <CustomDatePicker 
                                                defaultValue={info.disposalYmd || null}
                                                field={field} ref={ref} name={name} value={value} register={register} 
                                                setValue={setValue} fieldState={fieldState}
                                            />
                                            )}
                                        />
                                    </TableCell>
                                </TableRow>
                                {/* {(info.equipmentCtgr.parent.parent.code === 'EV' || info.equipmentCtgr.parent.parent.code === 'ES') && */}
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.chip.panel')}</TableCell>
                                    <TableCell className="email_pl">
                                        {liftControlPanels &&
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.controlPanelId ? "true" : "false"}
                                            control={control}
                                            name="controlPanelId"
                                            render={({ field: {name} }) => (
                                            <CustomFormSelect
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.chip.panel')}
                                                register={register}
                                                name={name}
                                                requiredMessage={t('message.common.error.text.liftControlPanel.select')}
                                                defaultValue={info.controlPanel?.id || '0'}
                                                list={liftControlPanels}
                                            />
                                            )}
                                        />
                                        }
                                        {errors.controlPanelId && <small role="alert"><br></br>{errors.controlPanelId.message}</small>}
                                    </TableCell>
                                    <TableCell colSpan={4}></TableCell>
                                </TableRow>
                                {/* } */}
                                {/* <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.picture.basic')}</TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                    <div style={{display:"flex", justifyContent: "space-between"}}>
                                        <div style={{display:"flex"}}>
                                            <input
                                                type="file" 
                                                accept="image/*" 
                                                onChange={(e)=>{
                                                    fileChangedHandler(e, 640, 480, setImgFile);
                                                    setImgFileId(null);
                                                }}
                                            />
                                            {imgFileId && 
                                                <>
                                                    <FileDownloadIcon file={info.imgFile} viewFileName={true} fontColor="#000" />
                                                    <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteImgFile()}>-</RemoveCircleOutlineIcon>
                                                </>
                                            }
                                        </div>
                                        <div style={{color:"red",fontWeight:"bold"}}>*{t('message.common.text.horizontal.picture.recommend')}</div>
                                    </div>
                                    </TableCell>
                                </TableRow> */}
                                <TableRow>
                                    <TableCell className="th" align="center">
                                        {t('message.common.subtitle.equipment.picture.basic')}
                                        {inputImageItems?.length < 4 && <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addImageFile}>+</AddCircleOutlineIcon>}
                                    </TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        {inputImageItems && inputImageItems.map(function(item, index) {
                                        return (
                                        <div key={index} style={{display:"flex"}}>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                value={''}
                                                onChange={e => {
                                                    handleImageFileChange(e, index);
                                                }}
                                            />
                                            {(item.file && item.file.name) ? item.file.name : (item.imgFile && item.imgFile.id && <><FileDownloadIcon file={item.imgFile} viewFileName={true} fontColor="#000" /></>)}
                                            { inputImageItems[index] ? (
                                                <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteImageFile(item.id)}>-</RemoveCircleOutlineIcon>
                                            ) : (
                                            ''
                                            )}
                                        </div>
                                        )
                                        })}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.picture.drawing')}</TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        <div style={{display:"flex"}}>
                                            <input 
                                                type="file" 
                                                accept="image/*" 
                                                onChange={(e)=>{
                                                    fileChangedHandler(e, 640, 480, setBpFile)
                                                    setBpFileId(null);
                                                }}
                                            />
                                            {bpFileId && 
                                                <>
                                                    <FileDownloadIcon file={info.bpFile} viewFileName={true} fontColor="#000" />
                                                    <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteBpFile()}>-</RemoveCircleOutlineIcon>
                                                </>
                                            }
                                        </div>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">
                                        {t('message.common.subtitle.equipment.picture.vr')}
                                        {inputVRItems.length < 8 && (
                                            <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addVRFile}>+</AddCircleOutlineIcon>
                                        )}
                                    </TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        {inputVRItems.map((item, index) => (
                                        <div key={index} style={{display:"flex"}}>
                                            <span style={{width:"20px", textAlign:"center", padding:"3px"}}>{(index+1)}. </span>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                value={''}
                                                onChange={e => {
                                                    handleInputVRFileChange(e, index);
                                                }}
                                            />
                                            {(item.file && item.file.name) ? item.file.name : <>{(item.vFile && item.vFile.id && <FileDownloadIcon file={item.vFile} viewFileName={true} fontColor="#000" />)}</>}
                                            { inputVRItems[index] ? (
                                                <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteInputVRFile(item.id)}>-</RemoveCircleOutlineIcon>
                                            ) : (
                                            ''
                                            )}
                                        </div>
                                        ))}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">
                                        {t('message.common.subtitle.manual.data')}
                                        <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addManualFile}>+</AddCircleOutlineIcon>
                                    </TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        {inputManualItems && inputManualItems.map(function(item, index) {
                                        return (
                                        <div key={index} style={{display:"flex"}}>
                                            <input
                                                type="file"
                                                value={''}
                                                onChange={e => {
                                                    handleManualFileChange(e, index);
                                                }}
                                            />
                                            {(item.file && item.file.name) ? item.file.name : (item.mFile && item.mFile.id && <><FileDownloadIcon file={item.mFile} viewFileName={true} fontColor="#000" /></>)}
                                            { inputManualItems[index] ? (
                                                <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteManualFile(item.id)}>-</RemoveCircleOutlineIcon>
                                            ) : (
                                            ''
                                            )}
                                        </div>
                                        )
                                        })}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.remark')}</TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.remark ? "true" : "false"}
                                            defaultValue={info.remark || ''}
                                            {...register("remark", {
                                            })} 
                                            multiline
                                            rows={3}
                                            sx={{ minWidth: '90%', backgroundColor: "#fff" }} />
                                        <div style={{color:"red",fontWeight:"bold",textAlign:"left"}}>* [{t('message.common.title.comprehensive.report.8.maintenance.main.communication.reflected')}]</div>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.opStatus')}</TableCell>
                                    <TableCell className="email_pl">
                                        {(info && info.opStatus && getEnumValueByEnumName("EquipmentOpStatus")) &&
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.opStatus ? "true" : "false"}
                                            control={control}
                                            name="opStatus"
                                            render={({ field: {name} }) => (
                                            <CustomFormEnumSelect
                                                key={'opStatus'}
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.opStatus')}
                                                register={register}
                                                name={name}
                                                requiredMessage={t('message.common.error.text.operating.state.select')}
                                                defaultValue={info && (info.opStatus || '')}
                                                list={getEnumValueByEnumName("EquipmentOpStatus")}
                                            />
                                            )}
                                        />
                                        }
                                        {errors.opStatus && <small role="alert"><br></br>{errors.opStatus.message}</small>}
                                    </TableCell>
                                    <TableCell colSpan={4}>&nbsp;
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </form>
            </MainCard>

            <div className="btn_right" style={{margin:"8px"}}>
                <LoadingButton variant="contained" color="success" loading={fileLoading} onClick={handleSubmit(onSubmit)}>{t('message.common.btn.modify')}</LoadingButton>&nbsp;&nbsp;
                <Button variant="contained" color="error" onClick={()=>{handleDeleteBtnClick(info.id)}}>{t('message.common.btn.delete')}</Button>
            </div>
        </>
        )
        //}
    } else {    // 등록
        return (
        <>
            <MainCard style={{marginTop:"10px"}}>
                <div style={{marginBottom:"10px"}}>
                    <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                    <Chip label={t('message.common.chip.equipment.information')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />
                </div>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <TableContainer style={{width:"100%"}}>
                        <Table sx={{ minWidth: 400 }} aria-label="simple table" style={{borderTop:"2px solid #a2a2a2"}}>
                            <TableBody style={{height:"auto"}}>
                                {/* <TableRow style={{marginTop:"5px"}}>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.subwayline')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.subwayCode ? "true" : "false"}
                                            control={control}
                                            name="subwayCode"
                                            render={({ field: {name} }) => (
                                            <CustomFormEnumSelect
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.subwayline')}
                                                register={register}
                                                name={name}
                                                requiredMessage={t('message.common.error.text.subwayline.select')}
                                                defaultValue={''}
                                                onChange={(e)=>{
                                                    setSubwayCode(e.target.value);
                                                }}
                                                list={getEnumValueByEnumName("SubwayLine")}
                                            />
                                            )}
                                        />
                                        {errors.subwayCode && <small role="alert"><br></br>{errors.subwayCode.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.workingPart')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.workingPartId ? "true" : "false"}
                                            control={control}
                                            name="workingPartId"
                                            render={({ field: {name} }) => (
                                            <CustomFormSelect
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.workingPart')}
                                                register={register}
                                                name={name}
                                                requiredMessage={t('message.common.error.text.workingPart.select')}
                                                defaultValue={''}
                                                onChange={(e)=>{
                                                    setWorkingPartId(e.target.value);
                                                }}
                                                list={workingParts}
                                            />
                                            )}
                                        />
                                        {errors.workingPartId && <small role="alert"><br></br>{errors.workingPartId.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.station')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.stationId ? "true" : "false"}
                                            control={control}
                                            name="stationId"
                                            render={({ field: {name} }) => (
                                            <CustomFormSelect
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.station')}
                                                register={register}
                                                name={name}
                                                requiredMessage={t('message.common.error.text.station.select')}
                                                defaultValue={''}
                                                onChange={(e)=>{
                                                    setStationId(e.target.value);
                                                }}
                                                list={stations}
                                            />
                                            )}
                                        />
                                        {errors.stationId && <small role="alert"><br></br>{errors.stationId.message}</small>}
                                    </TableCell>
                                </TableRow> */}
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level1')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.equipmentCategoryLevel1Id ? "true" : "false"}
                                            control={control}
                                            name="equipmentCategoryLevel1Id"
                                            render={({ field: {name} }) => (
                                            <CustomFormSelect
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.equipment.level1')}
                                                register={register}
                                                name={name}
                                                requiredMessage={t('message.common.error.text.level1.select')}
                                                defaultValue={''}
                                                onChange={(e)=>{
                                                    const val = e.target.value;
                                                    setEquipmentCategoryLevel1Id(val.split(",")[0]);
                                                    setEquipmentCategoryLevel1Code(val.split(",")[1]);
                                                }}
                                                list={equipmentCategoryLevel1s}
                                            />
                                            )}
                                        />
                                        {errors.equipmentCategoryLevel1Id && <small role="alert"><br></br>{errors.equipmentCategoryLevel1Id.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level2')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.equipmentCategoryLevel2Id ? "true" : "false"}
                                            control={control}
                                            name="equipmentCategoryLevel2Id"
                                            render={({ field: {name} }) => (
                                            <CustomFormSelect
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.equipment.level2')}
                                                register={register}
                                                name={name}
                                                requiredMessage={t('message.common.error.text.level2.select')}
                                                defaultValue={''}
                                                onChange={(e)=>{
                                                    setEquipmentCategoryLevel2Id(e.target.value);
                                                }}
                                                list={equipmentCategoryLevel2s}
                                            />
                                            )}
                                        />
                                        {errors.equipmentCategoryLevel2Id && <small role="alert"><br></br>{errors.equipmentCategoryLevel2Id.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level3')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.equipmentCategoryLevel3Id ? "true" : "false"}
                                            control={control}
                                            name="equipmentCategoryLevel3Id"
                                            render={({ field: {name} }) => (
                                            <CustomFormSelect
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.equipment.level3')}
                                                register={register}
                                                name={name}
                                                requiredMessage={t('message.common.alert.level3.select')}
                                                defaultValue={''}
                                                onChange={(e)=>{
                                                    setEquipmentCategoryLevel3Id(e.target.value);
                                                }}
                                                list={equipmentCategoryLevel3s}
                                            />
                                            )}
                                        />
                                        {errors.equipmentCategoryLevel3Id && <small role="alert"><br></br>{errors.equipmentCategoryLevel3Id.message}</small>}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.name')}</TableCell>
                                    <TableCell colSpan={3} className="email_pl">
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.name ? "true" : "false"}
                                            {...register("name", {
                                                required : t('message.common.alert.equipment.name.input')
                                            })} 
                                            sx={{ minWidth: '90%', backgroundColor: "#fff" }} />
                                        {errors.name && <small role="alert"><br></br>{errors.name.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">
                                        {t('message.common.subtitle.equipment.number')} &nbsp;
                                        <Button variant="contained" color="primary" onClick={()=>{equipmentNoSearch()}}>{t('message.common.btn.view')}</Button>
                                    </TableCell>
                                    <TableCell className="email_pl">
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.equipmentNo ? "true" : "false"}
                                            {...register("equipmentNo", {
                                                required : t('message.common.error.text.equipment.number.input')
                                            })} 
                                            sx={{ minWidth: '60%' , backgroundColor: "#fff"}} />
                                        {errors.equipmentNo && <small role="alert"><br></br>{errors.equipmentNo.message}</small>}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.installation.location')}</TableCell>
                                    <TableCell colSpan={3} className="email_pl">
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.location ? "true" : "false"}
                                            {...register("location", {
                                                required : t('message.common.error.text.installation.location.input')
                                            })} 
                                            sx={{ minWidth: '60%', backgroundColor: "#fff" }} />
                                        {errors.location && <small role="alert"><br></br>{errors.location.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.mfCpnyNm')}</TableCell>
                                    <TableCell className="email_pl">
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.mfCpnyNm ? "true" : "false"}
                                            {...register("mfCpnyNm", {
                                                required : t('message.common.error.text.production.company.input')
                                            })} 
                                            sx={{ minWidth: '60%', backgroundColor: "#fff" }} />
                                        {errors.mfCpnyNm && <small role="alert"><br></br>{errors.mfCpnyNm.message}</small>}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.madeYmd')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            control={control}
                                            name="madeYmd"
                                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                                            <CustomDatePicker
                                                defaultValue={dayjs(new Date()).format('YYYY-MM-DD')}
                                                field={field} ref={ref} name={name} value={value} register={register} 
                                                setValue={setValue} fieldState={fieldState}
                                            />
                                            )}
                                        />
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.installation.date')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            control={control}
                                            name="instlYmd"
                                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                                            <CustomDatePicker 
                                                defaultValue={dayjs(new Date()).format('YYYY-MM-DD')}
                                                field={field} ref={ref} name={name} value={value} register={register} 
                                                setValue={setValue} fieldState={fieldState}
                                            />
                                            )}
                                        />
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.disposal.date')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            control={control}
                                            name="disposalYmd"
                                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                                            <CustomDatePicker 
                                                defaultValue={dayjs(new Date()).format('YYYY-MM-DD')}
                                                field={field} ref={ref} name={name} value={value} register={register} 
                                                setValue={setValue} fieldState={fieldState}
                                            />
                                            )}
                                        />
                                    </TableCell>
                                </TableRow>
                                {/* {(equipmentCategoryLevel1Code && (equipmentCategoryLevel1Code === 'EV' || equipmentCategoryLevel1Code === 'ES')) && */}
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.chip.panel')}</TableCell>
                                    <TableCell className="email_pl">
                                        {liftControlPanels &&
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.controlPanelId ? "true" : "false"}
                                            control={control}
                                            name="controlPanelId"
                                            render={({ field: {name} }) => (
                                            <CustomFormSelect
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.chip.panel')}
                                                register={register}
                                                name={name}
                                                requiredMessage={t('message.common.error.text.liftControlPanel.select')}
                                                defaultValue={'0'}
                                                list={liftControlPanels}
                                            />
                                            )}
                                        />
                                        }
                                        {errors.controlPanelId && <small role="alert"><br></br>{errors.controlPanelId.message}</small>}
                                    </TableCell>
                                    <TableCell colSpan={4}></TableCell>
                                </TableRow>
                                {/* } */}
                                {/* <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.picture.basic')}</TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                    <div style={{display:"flex", justifyContent: "space-between"}}>
                                        <input
                                            type="file" 
                                            accept="image/*" 
                                            onChange={(e)=>
                                                fileChangedHandler(e, 640, 480, setImgFile)
                                            }
                                        />
                                        <div style={{color:"red",fontWeight:"bold"}}>*{t('message.common.text.horizontal.picture.recommend')}</div>
                                    </div>
                                    </TableCell>
                                </TableRow> */}
                                <TableRow>
                                    <TableCell className="th" align="center">
                                        {t('message.common.subtitle.equipment.picture.basic')}
                                        {inputImageItems?.length < 4 && <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addImageFile}>+</AddCircleOutlineIcon>}
                                    </TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        {inputImageItems.map((item, index) => (
                                        <div key={index} style={{display:"flex"}}>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                value={''}
                                                onChange={e => handleImageFileChange(e, index)}
                                            />
                                            {(item.file && item.file.name) ? item.file.name : (item.imgFile && item.imgFile.id && <><FileDownloadIcon file={item.imgFile} viewFileName={true} fontColor="#000"/></>)}
                                            { inputImageItems[index] ? (
                                                <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteImageFile(item.id)}>-</RemoveCircleOutlineIcon>
                                            ) : (
                                            ''
                                            )}
                                        </div>
                                        ))}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.picture.drawing')}</TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        <input 
                                            type="file" 
                                            accept="image/*" 
                                            onChange={(e)=>
                                                fileChangedHandler(e, 640, 480, setBpFile)
                                            }
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">
                                        {t('message.common.subtitle.equipment.picture.vr')}
                                        {inputVRItems.length < 8 && (
                                            <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addVRFile}>+</AddCircleOutlineIcon>
                                        )}
                                    </TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        {inputVRItems.map((item, index) => (
                                        <div key={index} style={{display:"flex"}}>
                                            {(index+1)}. 
                                            <input
                                                type="file"
                                                accept="image/*"
                                                value={''}
                                                onChange={(e) => {console.log(3);handleInputVRFileChange(e, index)}}
                                            />
                                            {(item.file && item.file.name) ? item.file.name : (item.vFile && item.vFile.id && <><FileDownloadIcon file={item.vFile} viewFileName={true} fontColor="#000" /></>)}
                                            { inputVRItems[index] ? (
                                                <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteInputVRFile(item.id)}>-</RemoveCircleOutlineIcon>
                                            ) : (
                                            ''
                                            )}
                                        </div>
                                        ))}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">
                                        {t('message.common.subtitle.manual.data')}
                                        <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addManualFile}>+</AddCircleOutlineIcon>
                                    </TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        {inputManualItems.map((item, index) => (
                                        <div key={index} style={{display:"flex"}}>
                                            <input
                                                type="file"
                                                value={''}
                                                onChange={e => handleManualFileChange(e, index)}
                                            />
                                            {(item.file && item.file.name) ? item.file.name : (item.mFile && item.mFile.id && <><FileDownloadIcon file={item.mFile} viewFileName={true} fontColor="#000"/></>)}
                                            { inputManualItems[index] ? (
                                                <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteManualFile(item.id)}>-</RemoveCircleOutlineIcon>
                                            ) : (
                                            ''
                                            )}
                                        </div>
                                        ))}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.remark')}</TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.remark ? "true" : "false"}
                                            {...register("remark", {
                                            })} 
                                            sx={{ minWidth: '90%', backgroundColor: "#fff" }} />
                                        <div style={{color:"red",fontWeight:"bold", textAlign:"left"}}>* [{t('message.common.title.comprehensive.report.8.maintenance.main.communication.reflected')}]</div>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.opStatus')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.opStatus ? "true" : "false"}
                                            control={control}
                                            name="opStatus"
                                            render={({ field: {name} }) => (
                                            <CustomFormEnumSelect
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.opStatus')}
                                                register={register}
                                                name={name}
                                                requiredMessage={t('message.common.error.text.operating.state.select')}
                                                defaultValue={''}
                                                list={getEnumValueByEnumName("EquipmentOpStatus")}
                                            />
                                            )}
                                        />
                                        {errors.opStatus && <small role="alert"><br></br>{errors.opStatus.message}</small>}
                                    </TableCell>
                                    <TableCell colSpan={4}>&nbsp;
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </form>
            </MainCard>

            <div className="btn_right" style={{margin:"8px"}}>
                <LoadingButton variant="contained" color="primary" loading={fileLoading} onClick={handleSubmit(onSubmit)}>{t('message.common.btn.write')}</LoadingButton>
            </div>
        </>
        )
    }
}

export default EquipmentForm;